import { Link } from 'react-router-dom';
import { LegalDocument } from '../components/LegalDocument';
// Vite's `?raw` suffix imports the file's text content as a plain string at
// build time (native Vite behavior, no plugin needed) — docs/legal/eula.md
// stays the ONE source of truth; this is a thin render, never a forked JSX
// copy of the content. The relative path reaches out of apps/throughline to
// the monorepo-root docs/ tree, the same "workspace-root-relative" reach the
// @careeropt/schema alias already makes from vite.config.ts (two levels up
// to the repo root, then into the sibling package) — proven safe by a real
// `npm run build` (see this lane's own gate results).
import eulaMarkdown from '../../../../docs/legal/eula.md?raw';
import styles from './Settings.module.css';

/**
 * /terms — renders docs/legal/eula.md in-app. Linked from SignIn, Settings,
 * and the enrollment consent step (ConsentGate.tsx). "EULA" is presented to
 * the user under the familiar "Terms" label/route (the mission's own route
 * naming) — the page's own H1 ("End User License Agreement — DRAFT...")
 * states precisely what it is, so nothing here re-labels or reframes the
 * source document's own honest self-description.
 */
export function Terms() {
  return (
    <div className={styles.page}>
      <Link to="/" className={styles.backButton}>
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" aria-hidden="true">
          <path
            d="M8 1L2 8l6 7"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Home
      </Link>
      <LegalDocument markdown={eulaMarkdown} />
    </div>
  );
}
